export default {
  displayName: 'Názov schémy zakladania',
  description: 'Popis schémy zakladania',
  partIds: 'Diely',
  assetIds: 'Zariadenia',
};
